import fetchClient from './fetchClient';

import { errorHandler } from './utils';


const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getPaginatedSuppliers = async (
    page: number,
    limit: number,
    search: string,
) => {
    const res: any = await fetchClient
        .get(
            `/suppliers?limit=${limit}&page=${page}&search=${search}`,
            config(),
        )
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getSuppliers = async () => {
    const res: any = await fetchClient
        .get('/suppliers?limit=5000', config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getSupplier = async (id: string) => {
    const res = await fetchClient.get(`/suppliers/${id}`, config()).catch((err) => {
        return null;
    });
    if (!res) return null;
    return res.data;
};

export const getSupplierPage = async (id: string) => {
    const res = await fetchClient
        .get(`/suppliers/page/${id}`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getCustomerLastOrder = async (id: string) => {
    const res = await fetchClient
        .get(`/customers/${id}/lastOrder`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const updateSupplier = async (customer: any) => {
    const id = customer._id;
    delete customer._id;
    const res: any = await fetchClient
        .put(`/suppliers/${id}`, customer, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const archiveSupplier = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/suppliers/${id}/archive`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const deleteSuppliers = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/suppliers/${id}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const createSupplier = async (customer: any) => {
    const res = await fetchClient
        .post('/suppliers', customer, config())
        .catch(errorHandler);
    return res.data;
};


export const getSupplierPurchaseStats = async (supplierId: string) => {
    const res = await fetchClient
        .get(`/suppliers/${supplierId}/purchase-stats`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getSupplierPurchasesByYear = async (supplierId: string, year: number) => {
    const res = await fetchClient
        .get(`/suppliers/${supplierId}/purchases-by-year?year=${year}`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getSupplierProducts = async (supplierId: string) => {
    try {
      const res = await fetch(`/api/suppliers/${supplierId}/products`, {
        credentials: 'include',
      });
      if (!res.ok) return [];
      return await res.json();
    } catch (e) {
      console.error('Failed to fetch supplier products', e);
      return [];
    }
  };

  export const addProductToSupplier = async (supplierId: string, productId: string) => {
    return fetchClient.post(`/suppliers/${supplierId}/products/${productId}`, {}, config());
  };
  
  export const removeProductFromSupplier = async (supplierId: string, productId: string) => {
    return fetchClient.delete(`/suppliers/${supplierId}/products/${productId}`, config());
  };

export const downloadAllSuppliers = async () => {
    try {
        const res = await fetchClient.get('/suppliers/export/csv', {
            ...config(),
            responseType: 'blob',
        });

        if (!res || !res.data) return null;

        const cd = (res.headers?.['content-disposition'] || '') as string;
        const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd || '');
        const filename = decodeURIComponent(match?.[1] || match?.[2] || 'fournisseurs.xlsx');

        const url = window.URL.createObjectURL(res.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        return true;
    } catch (err: any) {
        try {
            const blob = err?.response?.data as Blob | undefined;
            const text = blob ? await blob.text() : '';
            if (text) {
                const json = JSON.parse(text);
                errorHandler({ response: { data: { error: json?.error || 'Export impossible' } } });
            } else {
                errorHandler(err);
            }
        } catch {
            errorHandler(err);
        }
        return null;
    }
};
